/**
 * Number Editor
 * Handles configuration for number input controls
 */

import React from 'react';
import type { PropertyEditor, PropertyEditorProps } from '../../../registry/PropertyEditor.types';

/**
 * Render function for number control
 */
function renderNumberEditor(props: PropertyEditorProps) {
  const { control, onConfigChange } = props;

  return (
    <div className="af-properties-tab__section">
      <h4 className="af-properties-tab__subsection-title">Control Configuration</h4>
      <div className="af-properties-tab__group">
        <label className="af-properties-tab__label">
          Step
          <input
            type="number"
            min="0"
            value={(control.config?.step as number) ?? 1}
            onChange={(e) => onConfigChange('step', e.target.value ? parseFloat(e.target.value) : 1)}
            className="af-properties-tab__input"
            placeholder="1"
          />
        </label>
      </div>
    </div>
  );
}

/**
 * NumberEditor - Handles number input control configuration
 */
export const NumberEditor: PropertyEditor = {
  type: 'number',
  label: 'Number Input',
  description: 'Configure step value for number input control',
  render: renderNumberEditor,
};
